import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router'
import SimpleCrypto from "simple-crypto-js";

@Injectable({
    providedIn: 'root'
})

export class FileComplainService {
    baseUrl = environment.baseUrl;
    test: any;
    categories: any;
    DecryptData: any;
    simpleCrypto: SimpleCrypto;

    constructor(
        private _httpClient: HttpClient,
        private router: Router
    ) {
        var _secretKey = 'CXXD5qtFvXdq1o49w7l8iEHsLywmQOH7';
        this.simpleCrypto = new SimpleCrypto(_secretKey);
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getcategory()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getcategory(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.baseUrl + 'categories').subscribe((response: any) => {
                console.log('ooooooooooo', response)
                this.categories = response.data
                // var encrypted = this.categories
                // var decrypted = this.simpleCrypto.decrypt(encrypted, true);
                // this.DecryptData = decrypted
                resolve(response);
            }, reject);
        });
    }

    saveComplain(data): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.baseUrl + 'user/incident', data).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    getState(): Observable<any> {
        return this._httpClient.get(this.baseUrl + 'state')
    }

    getLga(id): Promise<any> {
        return new Promise((resolve, reject) => {
            if(id){
                this._httpClient.get(this.baseUrl + 'lga?state_id='+id)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
            }else{
                this._httpClient.get(this.baseUrl + 'lga')
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
            }
            
        });
    }

}
